var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80762 18.1364C12.1197 18.1364 15.6152 14.6408 15.6152 10.3287C15.6152 6.01671 12.1197 2.52112 7.80762 2.52112C3.49559 2.52112 0 6.01671 0 10.3287C0 14.6408 3.49559 18.1364 7.80762 18.1364Z",
    fill: "#B0EF8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89587 16.3634L7.79683 16.1947C6.28414 13.6174 2.26436 8.14788 2.22376 8.09294L2.16577 8.01417L3.53529 6.66071L7.87044 9.68782C10.6 6.14586 13.1464 3.71308 14.8075 2.29244C16.6245 0.738388 17.8073 0.0229559 17.8192 0.0161001L17.8461 0H20.1692L19.9473 0.197623C14.2402 5.28089 8.05439 16.0849 7.99278 16.1934L7.89587 16.3634Z",
    fill: "#009045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccess);
export default __webpack_public_path__ + "static/media/alert-success.076948446f457e379adfbde28191e2a7.svg";
export { ForwardRef as ReactComponent };